export default "__VITE_ASSET__oaT6mrhS__"